/**
 * 値が空かどうかを判定
 *
 * @param value 値
 * @returns 空かどうか
 */
export function isReallyBlank(value: any): boolean {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
  );
}
